var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"message"},[_vm._v(_vm._s(this.loadingMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }